import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Text} from "@mantine/core";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 1rem;
  padding: 6rem 2rem;
  @media (min-width: 868px) {
    flex-direction: row;
    justify-content: space-between;
    margin: 1rem 10rem;
  }
  @media (max-width: 768px) {
     padding: 2rem;
  }
`;

const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  @media (min-width: 868px) {
    margin-bottom: 0;
  }
`;

const RightColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 768px) {
    margin-left: 8rem;
  }
`;


function Testimonials() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  //google review
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <Container id="people">
      <LeftColumn>
        <Text
          style={{
            fontSize: isMobile ? "2rem" : "3rem",
            fontWeight: "500",
            fontFamily: "Paris Avenue",
            marginTop: "1rem",
          }}
        >
         What people are saying about us
        </Text>
      </LeftColumn>
      <RightColumn>
        <Text
          size="sm"
          style={{
            color: "#464545",
            fontFamily: "Poppins",
            fontWeight: "400",
            fontSize: "clamp(0.875rem, 0.8rem + 0.5vw, 1.2rem)",
            lineHeight: "1.6",
            "@media (max-width: 768px)": {
              fontSize: "1rem",
            },
            "@media (max-width: 480px)": {
              fontSize: "0.875rem",
            },
          }}
        >
          <div
            className="elfsight-app-401be722-dce5-407f-ab62-779a965480dc"
            data-elfsight-app-lazy
          ></div>
        </Text>
      </RightColumn>
    </Container>
  );
}

export default Testimonials;
